import React from "react";
import PropTypes from "prop-types";

import {
  filterBenchmarks,
  getBaseYearCollection,
} from "../benchmarking-project-selection/BenchmarkSelectionFilter.functions";

import BenchmarkingTable from "../benchmarking-project-selection/BenchmarkingTable";
import BenchmarkSelectionFilter from "../benchmarking-project-selection/BenchmarkSelectionFilter";

import {
  FormError,
  SaveForm,
} from "../benchmarking-collections/BenchmarkCollectionsButtons.components";

import "../benchmarking-project-selection/BenchmarkingTable.css";
import "../benchmarking-project-selection/ModalBenchmarkingSelection.css";

/// props validation | SQ(javascript:S6774)
BenchmarkCreateSelectionModal.propTypes = {
  benchmarks: PropTypes.array,
  setBenchmarks: PropTypes.func,
  benchmarkSelectionFilters: PropTypes.object,
  setBenchmarkSelectionFilters: PropTypes.func,
  benchmarkSelection: PropTypes.array,
  setBenchmarkSelection: PropTypes.func,
  benchmarkSelectionPage: PropTypes.number,
  setBenchmarkSelectionPage: PropTypes.func,
  user: PropTypes.object,
};
///
export default function BenchmarkCreateSelectionModal(props) {
  const { benchmarks } = props;
  const { benchmarkSelectionFilters, setBenchmarkSelectionFilters } = props;
  const { benchmarkSelection, setBenchmarkSelection, user } = props;

  // filter data to be supplied to BenchmarkingTableComponent
  const filteredData = filterBenchmarks(
    null,
    benchmarks,
    benchmarkSelectionFilters
  );

  return (
    <div className="benchmark-create-selection-modal">
      <div className="benchmark-selection-content-container">
        <div className="benchmark-table-flex">
          <BenchmarkSelectionFilter
            isPublishedDisabled={true}
            filters={benchmarkSelectionFilters}
            setFilters={setBenchmarkSelectionFilters}
            disableQuickBenchmarks={true}
            sortedBaseYear={getBaseYearCollection(benchmarks)}
          />
          <div className="benchmark-selection-table-container">
            <BenchmarkingTable
              data={filteredData}
              selection={benchmarkSelection}
              setSelection={setBenchmarkSelection}
              user={user}
            />
          </div>
        </div>
        <div className="general-row-container">
          <FormError {...props} />
        </div>
        <div className="benchmark-button-container">
          <SaveForm {...props} />
        </div>
      </div>
    </div>
  );
}
